// extracted by mini-css-extract-plugin
module.exports = {"sheet__description":"session_timeout__sheet__description___3ggJu"};